import React from 'react';

import { StyledMenuSubSection } from './MenuSubSection.styled';

const MenuSubSection = ({ subsection }) => {
  return (
    <StyledMenuSubSection>
      <div className='subsection-title'>
        <div className='subsection-title-decorator-vert' />
        <div className='subsection-title-decorator' />
        <div style={{paddingTop: '6px'}}>{subsection.name}</div>
      </div>
      {subsection.items.map((i) => <div className='subsection-item' onClick={() => i.onSelect()}><div className='subsection-item-decorator'/><div>{i.name}</div></div>)}
    </StyledMenuSubSection>
  );
};

export default MenuSubSection;

